import { defaultBookingState, type BookingState } from "@/types/booking";

const storageKey = "wasteking.booking.v1";

export function loadSavedBookingState(): BookingState | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const value = window.localStorage.getItem(storageKey);
    if (!value) {
      return null;
    }

    const parsedState = JSON.parse(value) as Partial<BookingState>;

    return {
      ...defaultBookingState,
      ...parsedState,
      bookingDetails: {
        ...defaultBookingState.bookingDetails,
        ...parsedState.bookingDetails,
      },
      supplementalItems: {
        ...defaultBookingState.supplementalItems,
        ...parsedState.supplementalItems,
      },
    };
  } catch {
    return null;
  }
}

export function loadBookingState(): BookingState {
  const savedState = loadSavedBookingState();

  if (!savedState) {
    return defaultBookingState;
  }

  return savedState;
}

export function saveBookingState(state: BookingState) {
  window.localStorage.setItem(storageKey, JSON.stringify(state));
}

export function clearBookingState() {
  window.localStorage.removeItem(storageKey);
}
